/* eslint-disable  */
import { IconButton } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";
import { PhotoCamera } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { bindActionCreators } from "redux";
import "../../../css/Pages/Pages.css";
import { authActionCreators } from "../../../service/action-creators";
import { GetNotifications } from "../../../service/action-creators/notificationAction";
import { GetCartProducts } from "../../../service/action-creators/userDataAction";
import Loader from "../../Loader";
import RenderHome from "../home/RenderHome";
import Resizer from "react-image-file-resizer";

const Input = styled("input")({ display: "none" });

const inputCls = "w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white";
const readonlyCls = "w-full px-3 py-2 border border-gray-200 rounded-lg text-sm bg-gray-50 text-gray-600 cursor-not-allowed";

const InfoField = ({ label, value, readOnly = true, type = "text", name, onChange }) => (
  <div>
    <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">{label}</label>
    <input
      type={type}
      name={name}
      defaultValue={value}
      readOnly={readOnly}
      onChange={onChange}
      className={readOnly ? readonlyCls : inputCls}
    />
  </div>
);

function UserProfile() {
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    UpdateProfile,
    UpdateProfileImage,
    UpdateCoverImage,
    ResetResponse,
    GetUserProfile,
  } = bindActionCreators(authActionCreators, dispatch);

  const auth = useSelector((state) => state?.auth);
  const isLoading = useSelector((state) => state?.auth?.isLoading);
  const user = auth?.user;

  const [formData, setFormData] = useState({});
  const [coverImagePreview, setCoverImagePreview] = useState(null);
  const [profileImagePreview, setProfileImagePreview] = useState(null);
  const [profileUrl, setProfileUrl] = useState("");

  const timestamp = new Date().getTime();

  const handlechange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCoverImageChange = (e) => {
    if (e?.target.files[0]) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (ev) => {
        setCoverImagePreview(ev.target.result);
        try {
          Resizer.imageFileResizer(file, 500, 200, "png", 100, 0, (uri) => {
            UpdateCoverImage(uri, user?.cover_image_key ?? "");
          }, "file", 200, 200);
        } catch (err) { console.log(err); }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleProfileImageChange = (e) => {
    if (e?.target.files[0]) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (ev) => {
        setProfileImagePreview(ev.target.result);
        try {
          Resizer.imageFileResizer(file, 500, 200, "png", 100, 0, (uri) => {
            UpdateProfileImage(uri, user?.profile_image_key ?? "");
          }, "file", 200, 200);
        } catch (err) { console.log(err); }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    UpdateProfile(formData, {
      profileImage: profileImagePreview,
      coverImage: coverImagePreview,
    });
  };

  useEffect(() => {
    GetUserProfile();
    dispatch(GetNotifications());
    dispatch(GetCartProducts());
    if (user) setFormData(user);
  }, []);

  useEffect(() => {
    setProfileUrl(user?.profile_image + "?" + timestamp);
  }, [user?.profile_image]);

  useEffect(() => {
    if (auth?.response?.state === "SUCCESS") {
      toast.success("Profile updated!");
      setTimeout(() => { GetUserProfile(); ResetResponse(); window.location.reload(true); }, 1500);
    } else if (auth?.response?.state === "FILE_UPLOADED") {
      GetUserProfile(); ResetResponse();
    } else if (auth?.response?.state === "ERROR") {
      toast.error(auth?.response?.message);
      setTimeout(() => ResetResponse(), 1500);
    }
  }, [auth?.response?.state]);

  const coverSrc = coverImagePreview || user?.cover_image;
  const avatarSrc = profileImagePreview || (user?.profile_image + "?" + timestamp);
  const initials = user?.name?.split(" ").slice(0, 2).map((n) => n[0]).join("").toUpperCase();

  return (
    <div>
      <RenderHome >
        {isLoading && <Loader />}

        <div style={{ maxWidth: "860px", margin: "0 auto", padding: "0 0 2rem" }}>

          {/* ── Cover + Avatar card ── */}
          <div className="bg-white rounded-xl shadow-md overflow-hidden mb-5">

            {/* Cover photo */}
            <div style={{ position: "relative", height: "160px", background: "#e5e7eb", overflow: "hidden" }}>
              {coverSrc
                ? <img src={coverSrc} alt="cover" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                : <div style={{ width: "100%", height: "100%", background: "linear-gradient(135deg, #01a94b 0%, #015f39 100%)" }} />
              }
              {/* Cover upload */}
              <label htmlFor="cover-upload"
                style={{ position: "absolute", bottom: "10px", right: "10px", background: "rgba(0,0,0,0.45)", borderRadius: "50%", width: "36px", height: "36px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#fff" }}>
                <Input accept="image/*" id="cover-upload" type="file" onChange={handleCoverImageChange} />
                <PhotoCamera style={{ fontSize: "18px" }} />
              </label>
            </div>

            {/* Avatar row */}
            <div style={{ padding: "0 1.5rem 1.5rem", display: "flex", flexWrap: "wrap", alignItems: "flex-end", gap: "1rem", marginTop: "-40px" }}>
              {/* Avatar */}
              <div style={{ position: "relative", flexShrink: 0 }}>
                <div style={{ width: "80px", height: "80px", borderRadius: "50%", border: "3px solid white", overflow: "hidden", background: "#01a94b", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 2px 8px rgba(0,0,0,0.15)" }}>
                  {avatarSrc && !avatarSrc.includes("undefined")
                    ? <img src={avatarSrc} alt="avatar" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                    : <span style={{ color: "#fff", fontSize: "1.5rem", fontWeight: 700 }}>{initials}</span>
                  }
                </div>
                <label htmlFor="avatar-upload"
                  style={{ position: "absolute", bottom: 0, right: 0, background: "#01a94b", borderRadius: "50%", width: "24px", height: "24px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#fff", border: "2px solid white" }}>
                  <Input accept="image/*" id="avatar-upload" type="file" onChange={handleProfileImageChange} />
                  <PhotoCamera style={{ fontSize: "13px" }} />
                </label>
              </div>

              {/* Name + sub */}
              <div style={{ flex: 1, minWidth: "150px", paddingTop: "2rem" }}>
                <h2 style={{ margin: 0, fontSize: "1.15rem", fontWeight: 700, color: "#111" }}>{user?.name || "—"}</h2>
                <p style={{ margin: "2px 0 0", fontSize: "0.78rem", color: "#6b7280" }}>{user?.staff_id} &nbsp;·&nbsp; {user?.facility}</p>
              </div>

              {/* Action buttons */}
              <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap", paddingTop: "1rem" }}>
                <button type="button" onClick={() => history.push("/home")}
                  style={{ padding: "0.45rem 1.1rem", border: "1.5px solid #d1d5db", borderRadius: "0.5rem", background: "#fff", color: "#374151", fontSize: "0.82rem", fontWeight: 600, cursor: "pointer" }}>
                  Cancel
                </button>
                <button type="button" onClick={handleSubmit}
                  style={{ padding: "0.45rem 1.1rem", border: "none", borderRadius: "0.5rem", background: "linear-gradient(135deg,#01a94b,#015f39)", color: "#fff", fontSize: "0.82rem", fontWeight: 600, cursor: "pointer", boxShadow: "0 2px 8px rgba(1,169,75,0.3)" }}>
                  Save Changes
                </button>
              </div>
            </div>
          </div>

          {/* ── Details grid ── */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "1.25rem", padding: "0 0" }}>

            {/* Editable info */}
            <div className="bg-white rounded-xl shadow-md p-6">
              <h3 style={{ margin: "0 0 1rem", fontSize: "0.95rem", fontWeight: 700, color: "#111", borderBottom: "2px solid #f0faf5", paddingBottom: "0.5rem" }}>
                Contact Info
              </h3>
              <div style={{ display: "flex", flexDirection: "column", gap: "0.85rem" }}>
                <InfoField label="Email Address" value={user?.email} />
                <InfoField label="Date of Birth" value={user?.dob} type="date" />
                <div>
                  <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Contact Number</label>
                  <input
                    type="tel"
                    name="phone_number"
                    defaultValue={user?.phone_number}
                    onChange={handlechange}
                    className={inputCls}
                    placeholder="Enter phone number"
                  />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">About / Description</label>
                  <textarea
                    name="description"
                    defaultValue={user?.description}
                    onChange={handlechange}
                    rows={3}
                    placeholder="Write a brief note about yourself…"
                    className={inputCls}
                    style={{ resize: "none" }}
                  />
                </div>
              </div>
            </div>

            {/* Read-only work info */}
            <div className="bg-white rounded-xl shadow-md p-6">
              <h3 style={{ margin: "0 0 1rem", fontSize: "0.95rem", fontWeight: 700, color: "#111", borderBottom: "2px solid #f0faf5", paddingBottom: "0.5rem" }}>
                Work Information <span style={{ fontSize: "0.7rem", color: "#9ca3af", fontWeight: 400 }}>(read-only)</span>
              </h3>
              <div style={{ display: "flex", flexDirection: "column", gap: "0.85rem" }}>
                <InfoField label="Staff ID" value={user?.staff_id} />
                <InfoField label="Full Name" value={user?.name} />
                <InfoField label="Facility" value={user?.facility} />
                <InfoField label="Department" value={user?.department} />
                <InfoField label="Region" value={user?.region} />
                <InfoField label="District" value={user?.district} />
              </div>
            </div>

          </div>
        </div>

        <ToastContainer autoClose={3000} />
      </RenderHome>
    </div>
  );
}

export default UserProfile;
